import InformationalModal from "./InformationalModal";

const DataSourceModal = () => {
  const text = () =>
    typeof window !== "undefined"
      ? `to the following page: ${window.location.href}`
      : "to a page...";

  return (
    <InformationalModal
      buttonText={"Information on data source"}
      variant="icon"
      title={"Where we get our data"}
      body={`We use data from one of the main accrediting bodies in the UK, MCS. If an installer asks us to manually update the list of services they offer or their contacts details, we display that instead`}
      secondaryButtonText={"Contact"}
      secondaryButtonLink={`mailto:hello@voltwise.co?subject=Voltwise Page Suggestion&body=Hi Voltwise Team, I'd like to suggest an update ${text}`}
    />
  );
};

export default DataSourceModal;
